// @flow
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

// vuex module
// used just to power the meta data and ingredients within articles (recipes)
// could be used for more in the future
const articleState = {
  namespaced: true,

  // state
  state: ({
    mode: 'original', // original|personalized
    cache: {}, // see flow type
    scaleLoading: false,
    scaleError: '',
    metaData: {
      mealType: '',
      dietaryType: '',
      prepTime: null,
      cookTime: null,
      servingSize: null,
      calories: null,
      fat: null,
      carbs: null,
      protein: null,
    },
    ingredients: {},
  }: ArticleState),

  // access / mutations
  mutations,
  actions,
  getters,
}

// default state
export default articleState

// helper to register module if it is not already loaded
export function registerArticleModule(store: Object) {
  if (!store.state.articles) {
    store.registerModule('articles', articleState)
  }
}
